import React from 'react'
import PropTypes from 'prop-types'

import AstuteCredentialsCard from './AstuteCredentialsCard'
import WealthManagersReferralCard from './WealthManagersReferralCard'

import "./preferences.scss"
import SubscriptionBillingCard from './SubscriptionBillingCard'
import { SecuritySettingsCard } from './SecuritySettingsCard'

const baseClass = "wb-preferences"

export const Preferences = (props) => {
  const showAstuteCredentials = props.featureToggles.astuteCcp
  const showSubscriptionDetails = props.permissions?.includes('organization-billing:show') ?? false
  
  return (
    <div className={`${baseClass}__container`}>
      <h1>Settings & Preferences</h1>

      { showAstuteCredentials &&
        <AstuteCredentialsCard {...props} />
      }

      { showSubscriptionDetails && 
        <SubscriptionBillingCard {...props} />
      }

      <SecuritySettingsCard securitySettingsPath={props.paths.securitySettingsPath} />

      <WealthManagersReferralCard
        wealthManagerUniqueSignupUrl={props.wealthManagerUniqueSignupUrl}/>
    </div>
  )
}

Preferences.propTypes = {
  astuteCredentials: PropTypes.object,
  billingDetails: PropTypes.object,

  permissions: PropTypes.arrayOf(PropTypes.string).isRequired,

  paths: PropTypes.exact({
    saveAstuteCredentialsPath: PropTypes.string.isRequired,
    saveBillingDetailsPath: PropTypes.string.isRequired,
    registerCardRedirectUrl: PropTypes.string.isRequired,
    initiateCheckoutPath: PropTypes.string.isRequired,
    removeCardPath: PropTypes.string.isRequired,
    securitySettingsPath: PropTypes.string.isRequired,
  }),

  wealthManagerUniqueSignupUrl: PropTypes.string.isRequired,

  tenantSlug: PropTypes.string.isRequired,

  featureToggles: PropTypes.shape({
    astuteCcp: PropTypes.bool
  }).isRequired
}

Preferences.defaultProps = {
  featureToggles: {}
}
